import { render, staticRenderFns } from "./User.Menu.Actions.vue?vue&type=template&id=5d1d8ece&scoped=true&"
import script from "./User.Menu.Actions.vue?vue&type=script&lang=js&"
export * from "./User.Menu.Actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1d8ece",
  null
  
)

export default component.exports